<template>
	<button
		type="button"
		class="mark-as-seen-button"
		:class="[
			{ 'light-background': props.lightBackground, 'is-marked': props.isMarked },
			`mark-as-seen-button--${props.size}`,
		]"
		role="button"
		@click.stop="$emit('mark-as-seen-button-click')"
	>
		<!-- Show icon by default -->
		<FontAwesomeIcon
			v-if="!saving"
			class="seen-icon"
			:class="{ 'seen-icon--seen': isMarked }"
			:icon="FA_ICONS[icon]"
		/>

		<!-- Show spinner, when saving -->
		<Spinner v-if="saving" class="spinner" color="light"></Spinner>
	</button>
</template>

<script setup lang="ts">
import { faStop } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import Spinner from '@/ui-components/Spinner.vue';

const props = withDefaults(
	defineProps<{
		lightBackground?: boolean;
		isMarked?: boolean;
		saving?: boolean;
		size?: 'small' | 'default';
		icon?: 'jw-check-icon' | 'stop';
	}>(),
	{
		size: 'default',
		icon: 'jw-check-icon',
	}
);

defineEmits<{
	(e: 'mark-as-seen-button-click'): void;
}>();

const FA_ICONS = {
	'jw-check-icon': jwCheckIcon,
	stop: faStop,
};
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.mark-as-seen-button {
	display: flex;
	justify-content: center;
	align-items: center;
	grid-area: icon;
	justify-self: end;
	margin: 0;
	min-height: 32px;
	height: 32px;
	min-width: 32px;
	width: 32px;
	padding-left: 0;
	padding-right: 0;
	font-size: 12px;
	background-color: $btn-mark-as-seen-color-darkblue;
	border-radius: 50%;
	border: none;
	transition: background-color 0.1s ease-in-out;

	&--small {
		min-width: 18px;
		width: 18px;
		min-height: 18px;
		height: 18px;
		display: flex;
		justify-content: center;
		align-items: center;

		.seen-icon {
			width: 60%;
			height: 60%;
		}
	}

	&:hover .seen-icon {
		color: $jw-color-lightgray--dark;
	}

	&.light-background {
		background-color: $jw-card-grey;
	}

	&.is-marked {
		background-color: $jw-color-green;
		.seen-icon--seen {
			color: $btn-remove-color;
		}

		&:hover {
			background-color: $jw-color-green--dark;
		}
	}

	.spinner {
		vertical-align: middle;
		height: 26px;
		width: 26px;
	}

	&:focus {
		outline: none;
	}
}

.seen-icon {
	color: $btn-mark-as-seen-color-grey;
	width: 14px;
	height: 31px;
	transition: color 0.1s ease-in-out;

	&--seen {
		color: $jw-color-green;
	}
}
</style>
